/**
 * The "Send to" box holds one address or several separated by commas — the API splits
 * on commas before handing the list to the mailer, so the two must agree on the shape.
 */
const EMAIL = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/;

export const parseRecipients = value =>
  String(value || '')
    .split(',')
    .map(address => address.trim())
    .filter(Boolean);

export const invalidRecipients = value =>
  parseRecipients(value).filter(address => !EMAIL.test(address));

/** Empty is valid: a form's confirmation template is delivered to whoever submitted it. */
export const recipientsError = value => {
  const invalid = invalidRecipients(value);
  if (!invalid.length) return '';
  return invalid.length === 1
    ? `"${invalid[0]}" is not a valid email address.`
    : `These are not valid email addresses: ${invalid.join(', ')}.`;
};
